const ContinueOrder = {
  options: {
    data: {},
    customization: {
      buttonTextColor: {
        type: 'HexColor',
        order: 1,
      },
      buttonBackgroundColor: {
        type: 'HexColor',
        order: 2,
      },
    },
    widgets: {},
  },
  variants: [
    {
      id: 'ContinueOrder_1',
      name: 'ContinueOrder_1',
      type: 'ContinueOrder',
      data: {
        text: '',
        images: [],
      },
      customization: {
        buttonTextColor: '#FFFFFF',
        buttonBackgroundColor: '#000000',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Cart+1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'ContinueOrder_2',
      name: 'ContinueOrder_2',
      type: 'ContinueOrder',
      data: {
        text: '',
        images: [],
      },
      customization: {
        buttonTextColor: '#FFFFFF',
        buttonBackgroundColor: '#008001',
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Cart+1.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};

export default ContinueOrder;
